import { Button, MenuItem, Stack, TextField, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Formik } from 'formik';
import { OrganizationPayload } from 'src/app/api/openapi';
import { OrganizationClient } from 'src/app/api/clients/organizations';

const CreateOrganization = () => {
  const navigate = useNavigate();

  const handleCreateOrganization = (values: OrganizationPayload) => {
    OrganizationClient.createOrg(values).then(() => navigate('/organizations'));
  };

  return (
    <Formik
      initialValues={{
        id: null,
        name: '',
        default_language: 'en_US',
        parent: null,
      }}
      onSubmit={handleCreateOrganization}
    >
      {({ submitForm, getFieldProps }) => (
        <>
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="h1">Create Organization</Typography>
            <Button variant="flat" onClick={submitForm}>
              Create
            </Button>
          </Stack>
          <Stack component="form" alignItems="center" width="100%">
            <Stack direction="row" width="100%">
              <TextField
                label="Organization Name"
                {...getFieldProps('name')}
                sx={{ m: 1, width: '100%' }}
              />
            </Stack>
            <Stack direction="row" width="100%">
              <TextField
                label="Default Language"
                select
                {...getFieldProps('default_language')}
                sx={{ m: 1, width: '100%' }}
              >
                <MenuItem value="en_US">English {`(US)`}</MenuItem>
                <MenuItem value="en_GB">English {`(UK)`}</MenuItem>
              </TextField>
            </Stack>
            {/* <Stack direction="row" width="100%">
              <TextField
                label="Parent Organization"
                select
                {...getFieldProps('parent')}
                sx={{ m: 1, width: '100%' }}
              >
                <MenuItem value="id">Org</MenuItem>
              </TextField>
            </Stack> */}
          </Stack>
        </>
      )}
    </Formik>
  );
};

export default CreateOrganization;
